import * as types from "./../types/types";

const initialState = {
  DSBPScreenData: [],
  loading: true,
  error: null,
};

const DSBPScreenReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.GET_DSBP_DETAILS_REQUEST:
      return { ...state, loading: true };
    case types.GET_ALL_DSBP_SCREEN_DATA: 
      return {
        ...state,
        DSBPScreenData: payload,
        loading: false,
        error: null,
      };

    case types.GET_ALL_DSBP_SCREEN_DATA_ERROR:
      return {
        ...state,
        DSBPScreenData: [],
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};
export default DSBPScreenReducer;
